





















































































































































































































import Vue from "vue";
import { mapGetters, mapMutations, mapActions } from "vuex";

export default Vue.extend({
  name: "CardList",
  data() {
    return {
      searchDebounce: null,
      search: "",
      selected: [],
      file: null,
      perPage: 10,
      limits: [10, 20, 50, 100, 200, 500, 1000]
    };
  },
  methods: {
    ...mapMutations({
      openModalAdd: "farmer/openModalAdd",
      openModalEdit: "farmer/openModalEdit",
      handleShowModal: "historyPoints/handleShowModal",
      setShowModal: "farmerSpinResult/setShowModal",
      resetQuerySpin: "farmerSpinResult/resetQuery",
      resetQueryHistory: "historyPoints/resetQuery",
      showModalExportCSV: "pickDayCSV/changeShow",
      handleShowPinModal: "updatePin/handleShowModal",
      setFarmerCode: "updatePin/setFarmerCode"
    }),
    ...mapActions({
      deleteFarmer: "farmer/deleteFarmer",
      deleteListFarmer: "farmer/deleteListFarmer",
      pageChange: "farmer/pageChange",
      perPageChange: "farmer/perPageChange",
      searchFarmer: "farmer/searchFarmer",
      upLoadCSV: "farmer/upLoadCSV",
      getCSVTemplate: "farmer/getCSVTemplate",
      changeStatusCard: "farmer/changeStatusCard",
      getBonusPointHistoryByFarmer:
        "historyPoints/getBonusPointHistoryByFarmer",
      getFarmerSpinResult: "farmerSpinResult/getFarmerSpinResult"
    }),
    openHistoryPoint(id: string) {
      this.handleShowModal(true);
      this.resetQueryHistory();
      this.getBonusPointHistoryByFarmer(id);
    },
    openHistorySpin(id: string) {
      this.setShowModal(true);
      this.resetQuerySpin();
      this.getFarmerSpinResult(id);
    },
    removeSelected() {
      const selectedId = this.selected.map(item => item._id);
      this.deleteListFarmer(selectedId);
    },
    createWhiteList() {},
    handleUpdatePin(id: string) {
      // TODO: Đỗi mã pin nông dân
      this.setFarmerCode({
        showModal: true,
        farmerId: id,
        mode: "farmer"
      });
    },

    searchChanged() {
      if (this.searchDebounce) clearTimeout(this.searchDebounce);
      this.searchDebounce = setTimeout(() => {
        this.searchFarmer(this.search);
      }, 500);
    },

    onPageChange(page) {
      this.pageChange(page);
    },
    perPageChanged() {
      this.perPageChange(this.perPage);
    },
    upload() {
      this.upLoadCSV(this.file);
    }
  },
  computed: {
    ...mapGetters({
      farmers: "farmer/farmers",
      loadingFarmers: "farmer/loadingFarmers",
      count: "farmer/count",
      upLoading: "farmer/upCSVLoading"
    })
  }
});
